import {ReportData} from "../../../reports/report.data";
import {collection, EntityData, field, identifier} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";

export class StockInventoryGroupData extends EntityData<StockInventoryGroupData> {
    @field invGroupId: number;
    @field name: string;
}

export class StockMovementAuditReportData extends ReportData<StockMovementAuditReportData> {
    @collection() groupBy: string[] = ["none"];
    @field reportType: string = "SIMPLE";

    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @collection() stockMovement: String[];

}
